import { SourceCitationBase } from "./source-citation-base";
import { SourceBase } from '../source/source-base';

export class SourceCitationViewModel extends SourceCitationBase{
    eventId: number;
    sourceBase : SourceBase;
}